import { AdjustTerms, isUndefined } from '@aloft/toolkit-shared';
import { Flex, Modal, Select, SimpleInput } from '@aloft/toolkit-sui';
import { UseDisclosureReturn } from '@aloft/toolkit-sui/chakra';

import { Controller } from 'react-hook-form';

import { useModuleContext } from '../../shared/moduleContext/useModuleContext.js';
import { STUDY_TERMS } from '../constants.js';
import { useAddStudyForm } from '../hooks/useAddStudyForm.js';

const termOptions = STUDY_TERMS.map((key) => ({
  label: AdjustTerms[key].label,
  value: key,
})).sort((a, b) => a.label.localeCompare(b.label));

export const AddStudyModal = ({ modalProps }: { modalProps: UseDisclosureReturn }) => {
  const {
    navigation: { useNavigate },
  } = useModuleContext();

  const navigate = useNavigate();

  const { control, formState, resetField, handleSubmit, watch } = useAddStudyForm({
    onSubmit: (data) => {
      navigate('paired-sales', { state: data });
    },
  });

  const analysisFeature = watch('analysisFeature');

  return (
    <Modal
      {...modalProps}
      title="What do you want to analyze?"
      primaryAction={{
        text: 'Save',
        onClick: handleSubmit,
        disabled: !formState.isValid,
      }}
      secondaryAction={{ text: 'Cancel', onClick: () => modalProps.onClose() }}
    >
      <Flex flexDirection="column" gap={4}>
        <Controller
          name="analysisFeature"
          control={control}
          render={({ field, fieldState }) => (
            <Select
              label="Feature"
              {...field}
              options={[...termOptions, { label: 'Other', value: 'custom' }]}
              onChange={(e) => {
                if (isUndefined(e)) {
                  resetField(`analysisFeature`);
                } else {
                  field.onChange(e);
                }
              }}
              isInvalid={fieldState.invalid}
              placeholder=" "
            />
          )}
        />
        {analysisFeature === 'custom' && (
          <Controller
            name="customAnalysisFeatureName"
            control={control}
            render={({ field, fieldState }) => (
              <SimpleInput
                label="Feature Name"
                {...field}
                onChange={(e) => {
                  if (isUndefined(e)) {
                    resetField(`customAnalysisFeatureName`);
                  } else {
                    field.onChange(e);
                  }
                }}
                invalid={fieldState.invalid}
              />
            )}
          />
        )}
      </Flex>
    </Modal>
  );
};
